import script from "./TaskPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskPreview.vue?vue&type=script&setup=true&lang=js"

import "./TaskPreview.vue?vue&type=style&index=0&id=0e217070&lang=scss&scoped=true"
import "./TaskPreview.vue?vue&type=style&index=1&id=0e217070&lang=scss"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e217070"]])

export default __exports__